/* 🤖 this file was generated by svg-to-ts */
export const matIconHourglassBottom: {
  name: 'hourglass-bottom';
  data: string;
} = {
  name: 'hourglass-bottom',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m18 22-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"/></svg>`
};
